module.exports = __webpack_public_path__ + "assets/8137d5a9ad0e53bd99291c3fffb3ab29.png";